import { ColumnDef } from '@tanstack/react-table'
import { AddButton } from 'components/CantileverButton'
import { useClickOutside } from 'components/table/enhancements/filters/filterUtils'
import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { RelativeWrap } from 'styles/assetDatabaseStyles'

const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  position: absolute;
  width: max-content;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.forecast.glassBackground};
  backdrop-filter: blur(32px);
  box-shadow:
    0rem 0.0625rem 0.125rem 0rem ${({ theme }) => theme.forecast.boxShadow},
    0rem 0.25rem 0.5rem 0rem ${({ theme }) => theme.forecast.boxShadow};
  -webkit-backdrop-filter: blur(32px);
`

const DropdownItem = styled.div`
  display: flex;
  min-height: 40px;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  cursor: pointer;
  font-weight: 500;
  color: ${({ theme }) => theme.forecast.defaultText};

  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }

  &:active {
    color: ${({ theme }) => theme.forecast.activeText};
    background-color: ${({ theme }) => theme.forecast.cardBackground};
  }
`

export const AddFilter = <TData,>({
  columns,
  setActiveFilters,
}: {
  columns: ColumnDef<TData>[]
  setActiveFilters: React.Dispatch<React.SetStateAction<string[]>>
}) => {
  const addFilterRef = useRef<HTMLDivElement>(null)
  const [dropdownVisible, setDropdownVisible] = useState<boolean>(false)
  const handleAddFilter = () => {
    setDropdownVisible((prevState) => !prevState)
  }

  const handleSelectFilter = (id: string | undefined) => {
    setDropdownVisible((prevState) => !prevState)
    setActiveFilters((prevActiveFilters) => {
      if (id && !prevActiveFilters.includes(id)) {
        return [...prevActiveFilters, id]
      }
      return prevActiveFilters
    })
  }

  const handleOutsideClick = () => {
    setDropdownVisible(false)
  }

  useClickOutside(addFilterRef, handleOutsideClick)
  return (
    <RelativeWrap ref={addFilterRef}>
      <AddButton entityName='filter' onClick={handleAddFilter} />
      {dropdownVisible && (
        <Dropdown>
          {columns.map(
            (column) =>
              column.id &&
              column.id !== 'actions' &&
              column.enableColumnFilter !== false && (
                <DropdownItem
                  key={column.id}
                  onClick={() => handleSelectFilter(column.id)}>
                  {String(column.header)}
                </DropdownItem>
              )
          )}
        </Dropdown>
      )}
    </RelativeWrap>
  )
}
